import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Firebase web config is safe to expose in client code. Values can be
// overridden via environment variables for different deployments.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyDJIb6GCgn6uyyI2FfxhJXEclzwYbiFl5I',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'workflowdesk-itsm.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'workflowdesk-itsm',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'workflowdesk-itsm.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '83867075040',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:83867075040:web:e7a89ce26c7df95746ab85',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
